module.exports = __webpack_public_path__ + "12ee6c7be1e48bd1cbaa0352982988a8.jpg";